<template>
  <div>
    <v-card
      style="
        box-shadow: -1px 1px 7px 0px rgba(224, 37, 37, 0.45);
        -webkit-box-shadow: -1px 1px 7px 0px rgba(224, 37, 37, 0.45);
        -moz-box-shadow: -1px 1px 7px 0px rgba(224, 37, 37, 0.45);
      "
      class="mt-5"
    >
      <v-card-text>
        <v-row class="pa-0 custom-header-actions-cl">
          <v-col cols="12" class="pa-0">
            <customer-toolbar
              :pending-payments="seller.APPEN"
              @billingTypeChange="billingType = $event"
              @search="searchCustomers"
            />
          </v-col>
        </v-row>
        <v-simple-table v-if="!errorMessage" class="my-table w-full">
          <template #default>
            <customers-table-heading
              :loading="loading"
              :billing-type="billingType"
              :data="filteredCustomers"
              @showMore="isShowMore = $event"
              @sortedData="sortCustomers"
            />

            <tbody class="custom-table-bordered">
              <template v-if="!loading">
                <customer-table-row
                  v-for="(customer, index) in filteredCustomers"
                  :key="index"
                  :customer="customer"
                  :billing-type="billingType"
                  :is-show-more="isShowMore"
                  @showPayments="loadPayments"
                  @showPie="getSalesByArea"
                  @onShowPhoto="showCustomerImages"
                  @onUpdateCustomerImages="cIForm = $event"
                  @updatePromissoryNote="showNewPromissoryNote"
                  @showCumulativeGrowth="getCumulativeGrowth"
                />
                <td v-if="!isShowMore" colspan="13" />
                <td
                  class="bg-black text-white subtitle-1 pa-1"
                  :colspan="isShowMore && billingType != 1 ? 1 : 0"
                >
                  Total
                </td>
                <template v-if="billingType != 1">
                  <td v-if="isShowMore">
                    {{ formatNumber(customerResume.AVG12, '$', 0) }}
                  </td>
                  <td
                    v-for="(item, index) in customerResume.MONTHS.slice(
                      0,
                      isShowMore ? 13 : 4
                    )"
                    :key="`M${index}`"
                    class="font-weigth-bold"
                  >
                    {{ formatNumber(item.AMOUNT, '$', 0) }}
                  </td>
                </template>
                <template v-else>
                  <td
                    v-for="(item, index) in customerResume.QUARTERS.slice(
                      0,
                      isShowMore ? 13 : 4
                    )"
                    :key="`Q${index}`"
                    class="font-weigth-bold"
                  >
                    {{ formatNumber(item.AMOUNT, '$', 0) }}
                  </td>
                </template>
              </template>
              <tr v-if="loading">
                <td colspan="19">
                  <v-skeleton-loader type="table-row-divider@10" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <alert-prominent
          v-if="errorMessage"
          :message="errorMessage"
          :dismissible="true"
        />
        <div class="d-flex my-4 text-black text-caption font-weight-bold">
          <div class="mr-auto">
            <v-icon color="#F71FFF" class="mr-1" size="20">
              mdi-account-check
            </v-icon>
            <span> Cliente Nuevo (12 Meses)</span>
          </div>
          <div>
            <v-icon class="mr-1 in-stock-text" size="20"> mdi-circle </v-icon>
            <span> Con existencia 100% </span>
            <v-icon class="mr-1 partial-stock-text" size="20">
              mdi-circle
            </v-icon>
            <span> Con existencias parciales </span>
            <v-icon class="mr-1 no-stock-text" size="20"> mdi-circle </v-icon>
            <span> Sin existencias </span>
            <v-icon class="mr-1 programmed-stock-text" size="20">
              mdi-circle
            </v-icon>
            <span> Programado </span>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- modals -->
    <cumulative-growth
      v-model="cumulativeGrowth.modal"
      current-key-value="detail.current"
      old-key-value="detail.last"
      month-key-value="SPMON"
      amount-key-value="FACPER"
      total-current-key-value="sumBillingActual"
      total-old-key-value="sumBillingCompared"
      total-percent-key-value="cumulativeGrowth"
      :loading="cumulativeGrowth.loading"
      :data="cumulativeGrowth.data"
    />

    <create-promissory-note
      v-model="promissoryNote.dialog"
      :customer-info="promissoryNote.info"
      @requestSubmitted="refresh()"
    />

    <update-customer-images-form
      :dialog-model="cIForm.modal"
      :document="cIForm.document"
      :user-id="cIForm.userId"
      :customer-id="cIForm.customerId"
      @updatedPhotos="updateCustomerPhotos"
      @closeModal="cIForm.modal = false"
    />

    <customer-payment-types
      v-model="customerPayments.modal"
      :loading="customerPayments.loading"
      :data="customerPayments.data"
      :errors="customerPayments.errors"
    />

    <graph
      v-model="salesByArea.modal"
      :char-title="salesByArea.charTitle"
      :loading="salesByArea.loading"
      :data="salesByArea.data"
      :errors="salesByArea.error"
      @onPeriodChange="updateSalesByArea"
    />
    <cool-light-box
      :items="customerImages"
      :index="index"
      @close="index = null"
    />
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import CumulativeGrowth from '@/components/modals/CumulativeGrowth.vue';
  import Graph from './modals/Graph.vue';
  import CustomerPaymentTypes from './modals/CustomerPaymentTypes.vue';
  import CoolLightBox from 'vue-cool-lightbox';
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
  import {
    getSalesByArea,
    getCumulativeGrowth,
    getIelPaymentsDetail,
    getCustomersSummary,
  } from '@/repositories/Daily';
  import CreatePromissoryNote from '@/views/client_request/promissory_notes/CreatePromissoryNote.vue';
  import UpdateCustomerImagesForm from '@/components/forms/UpdateCustomerImagesForm.vue';
  import CustomersTableHeading from '../components/CustomersTableHeading.vue';
  import CustomerToolbar from '../components/CustomerToolbar.vue';
  import CustomerTableRow from '@/views/seller/components/CustomerTableRow.vue';
  import AlertProminent from '@/components/AlertProminent.vue';
  import service from '@/mixins/service';
  import numbersFormats from '@/mixins/numbersFormats';
  export default {
    name: 'CustomerList',
    components: {
      CumulativeGrowth,
      Graph,
      CustomerToolbar,
      CoolLightBox,
      CreatePromissoryNote,
      CustomerPaymentTypes,
      UpdateCustomerImagesForm,
      CustomersTableHeading,
      CustomerTableRow,
      AlertProminent,
    },
    mixins: [service, numbersFormats],
    props: [
      'user', //Auth user
      'seller', //general info
    ],
    data() {
      return {
        cumulativeGrowth: {
          modal: false,
          loading: true,
          data: null,
        },
        customerPayments: {
          loading: true,
          data: [],
          modal: false,
          errors: null,
        },
        salesByArea: {
          loading: true,
          data: [],
          modal: false,
          error: null,
          year: null,
          quarter: null,
          charTitle: '',
          customer: null,
        },
        cIForm: {
          modal: false,
          document: {},
          userId: null,
          customerId: null,
          customer: null,
        },
        form: {
          facade_photo: [],
          indoor_photo: [],
          bar_photo: [],
        },
        customerResume: [],
        loading: true,
        minMaxPayments: [],
        billingType: '1',
        filteredCustomers: [],
        allCustomers: [],
        searchCustomerInput: '',
        isShowMore: false,
        customerImages: [],
        index: null,
        promissoryNote: {
          dialog: false,
          info: {
            channel: null,
            customerId: null,
          },
        },
        errorMessage: '',
      };
    },
    watch: {
      seller() {
        this.getData();
      },
    },
    created() {
      const quarters = this.getQuartersList(1);
      this.salesByArea.quarter = quarters[0].quarter;
      this.salesByArea.year = quarters[0].year;
    },
    methods: {
      refresh() {
        this.getData();
      },
      sortCustomers(customersOrdered) {
        this.filteredCustomers = customersOrdered;
      },
      async getCumulativeGrowth(customer) {
        this.cumulativeGrowth.modal = true;
        this.cumulativeGrowth.loading = true;
        try {
          this.cumulativeGrowth.data = await getCumulativeGrowth(
            customer,
            this.seller.VTWEG,
            1
          );
        } catch (error) {
          this.$toast.error(
            'No se pudo cargar el crecimiento acumulado del cliente'
          );
          this.cumulativeGrowth.modal = false;
          this.cumulativeGrowth.data = null;
        }
        this.cumulativeGrowth.loading = false;
      },
      showCustomerImages(event) {
        this.index = 1;
        this.customerImages = event;
      },
      updateSalesByArea(period) {
        this.salesByArea.year = period.year;
        this.salesByArea.quarter = period.quarter;
        this.getSalesByArea(this.salesByArea.customer, period);
      },
      async getSalesByArea(customer, period = null) {
        this.salesByArea.charTitle = `Participación por division del cliente ${customer}`;
        this.salesByArea.customer = customer;
        this.salesByArea.loading = true;
        this.salesByArea.modal = true;
        period = period ? period : this.salesByArea;
        try {
          this.salesByArea.data = await getSalesByArea(
            customer,
            this.seller.VTWEG,
            period.quarter,
            period.year
          );
        } catch (error) {
          this.salesByArea.modal = false;
          this.$toast.error(
            'Hubo problemas al cargar la participación por división, por favor intente más tarde.'
          );
        }
        this.salesByArea.loading = false;
      },
      async loadPayments(customer) {
        this.customerPayments.loading = true;
        this.customerPayments.modal = true;
        try {
          this.customerPayments.data = await getIelPaymentsDetail(
            customer,
            this.seller.VTWEG
          );
        } catch (error) {
          this.customerPayments.errors = error;
        }
        this.customerPayments.loading = false;
      },

      updateCustomerPhotos(documents) {
        this.cIForm.document = documents;
        this.syncCustomer(this.cIForm.customer, documents);
      },

      async syncCustomer(customerData, documents) {
        var indexSelected = this.filteredCustomers.findIndex(
          (item) => item.KUNNR == customerData.KUNNR
        );
        this.filteredCustomers[indexSelected].DOCUMENT = documents;
        this.filteredCustomers[indexSelected].ROTUL = 1;
        this.filteredCustomers[indexSelected].hasSignagePhotos =
          documents.storefront_signage_photo1 ? true : false;
      },
      searchCustomers(search) {
        const customers = this.allCustomers;
        const toSearch = search.toUpperCase();
        const searchItems = customers.filter(
          (i) =>
            i.id == toSearch ||
            i.name == toSearch ||
            i.shortName.includes(toSearch) ||
            i.id.toString().includes(toSearch)
        );
        this.filteredCustomers = searchItems;
      },
      async getData() {
        this.loading = true;
        this.errorMessage = '';
        try {
          const response = await getCustomersSummary(
            this.seller.PERNR,
            this.seller.VTWEG
          );
          this.allCustomers = response.data;
          this.filteredCustomers = this.allCustomers;
          this.customerResume = response?.resume;
        } catch (error) {
          this.errorMessage =
            'No se ha podido cargar correctamente el listado de clientes.';
        }
        this.loading = false;
        this.$emit('desactiveLoader');
      },
      showNewPromissoryNote(data) {
        this.promissoryNote.info = {
          customerId: data.id,
          channel: this.seller.VTWEG,
          creditAmount: data.credit.available,
          promissoryNoteAmount: data?.person?.document?.promissory_note_amount,
          promissoryNoteDate: data?.person?.document?.promissory_note_date,
          bankGuaranteeName: data?.person?.document?.bank_guarantee_name,
          userId: data?.person?.userId,
        };
        this.promissoryNote.dialog = true;
      },
    },
  };
</script>

<style scoped src="../../../../public/css/seller.css"></style>
